import React, { Fragment } from "react";
import { Col } from "reactstrap";
import LoginBoxed from "../LoginBoxed";

const LoginV2 = () => {
  return (
    <Fragment>
      <div className="h-100 bg-plum-plate bg-animation">
        <div className="d-flex h-100 justify-content-center align-items-center">
          <Col md="8" className="mx-auto app-login-box">
            <div className="app-logo-inverse mx-auto mb-3" />
            <LoginBoxed />

            <div className="text-center text-white opacity-8 mt-3">
              Copyright &copy; CyberSPF 2023
            </div>
          </Col>
        </div>
      </div>
    </Fragment>
  );
};

export default LoginV2;
